import { Skeleton, Box } from 'vvs-uikit'
import { ResponsiveGrid } from './styles'

export const LeaderboardDataLoader: React.FC = () => {
  const loadingRow = (
    <ResponsiveGrid type="loader">
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </ResponsiveGrid>
  )
  return (
    <Box pt="12px" background="white">
      {loadingRow}
      {loadingRow}
      {loadingRow}
      {loadingRow}
      {loadingRow}
    </Box>
  )
}
